export const APPROVAL_TIMEOUT_MS = 45_000;

export const APPROVAL_TIMEOUT_MESSAGE =
  "Approval timed out. Ask the user to return to the tab and Approve or Reject. Then call understudy_publish_tool again to collect the outcome.";
